import { useBenchmark } from "@/contexts/BenchmarkContext";
import { useCallback } from "react";

export const useBenchmarkedFetch = () => {
  const { addBenchmarkEntry } = useBenchmark();

  const fetch = useCallback(
    async (
      input: RequestInfo,
      init?: RequestInit,
      benchmarkLabel?: string,
    ): Promise<Response> => {
      const start = performance.now();
      console.log("[useBenchmarkedFetch] Fetching:", input, "init:", init);
      try {
        const response = await globalThis.fetch(input, init);
        const end = performance.now();
        const durationMs = end - start;

        console.log(
          "[useBenchmarkedFetch] Response:",
          response.status,
          response.statusText,
        );
        // Log benchmark entry
        addBenchmarkEntry({
          name: benchmarkLabel || `Fetch ${input}`,
          durationMs,
          timestamp: Date.now(),
        });
        return response;
      } catch (error) {
        const end = performance.now();
        const durationMs = end - start;
        console.error("[useBenchmarkedFetch] Fetch error:", error);
        addBenchmarkEntry({
          name: benchmarkLabel || `Fetch ${input} error: ${error}`,
          durationMs,
          timestamp: Date.now(),
        });
        throw error;
      }
    },
    [addBenchmarkEntry],
  );
  return { fetch };
};
